import { AfterViewInit, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { AppState } from '../../../reducers';
// import { MosInputPasswordRedactionDirective, MosModalComponent } from 'merceros-ui-components';
import { LoginAction } from '../auth.actions';
import { selectStaticData } from '../../../shared/layout/main.selectors';
import { Observable } from 'rxjs';
import { StaticData } from '../../../global/interfaces';
import { Router } from '@angular/router';
import { LoginFacadeService } from 'ngpd-merceros-authentication-fe-components/core';
import { environment } from '../../../../environments/environment';
import { ModalModule, ModalComponent } from 'atlas-modal';
import { DialogSizings } from 'atlas-cdk';

@Component({
  standalone: false,
  selector: 'dsp-login',
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.scss']
})
export class LoginComponent implements OnInit, AfterViewInit {
  //@ViewChild(MosInputPasswordRedactionDirective)
  //public password: MosInputPasswordRedactionDirective;

  //@ViewChild(MosModalComponent)
  //public modal: MosModalComponent;

  @ViewChild('contactUs')
  public contactUs: ModalComponent

  @ViewChild('redirectModal')
  public redirectModal: ModalComponent;

  public staticData$: Observable<StaticData>;
  public modalSize: DialogSizings = DialogSizings.xlarge;

  public form: FormGroup;
  federatedOnly = false;
  loginForm: FormGroup;
  isBranded$ = this._loginFacade.isBranded$;
  public env = environment;

  public readonly oldUrl: string = window.location.origin;
  public readonly newUrl: string = `${(environment.rpid || '').replace(/\/$/, '')}`;

  private redirectModalOpen = false;

  public constructor(
    private readonly router: Router,
    private readonly store: Store<AppState>,
    private readonly _formBuilder: FormBuilder,
    private readonly _loginFacade: LoginFacadeService
  ) {
    this.staticData$ = this.store.pipe(select(selectStaticData));
  }

  public ngOnInit(): void {
    this.loginForm = new FormGroup({
      username: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', [Validators.required])
    });

    // this.loginForm = this._formBuilder.group({
    //   username: this._formBuilder.control(null, [
    //     Validators.required,
    //     Validators.pattern(/^[a-zA-Z0-9.!#$%&\'*+\/=?^_`{|}~-]+@[a-zA-Z0-9]
    //(?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9]))+$/)
    //   ]),
    //   password: this._formBuilder.control(null),
    // });
  }

  public onLogin(): void {
    this.store.dispatch(new LoginAction(this.loginForm.value));
  }

  public toggleVisible(): void {
    //this.password.maskField = !this.password.maskField;
  }

  public onContactUs(): void {
    this.contactUs.launch()
  }

  // public forgotPassword() {
  //   this.router.navigate(['/provision/forgot-password'], { queryParamsHandling: 'preserve' });
  // }

  public ngAfterViewInit() {
    this.openRedirectModal();
  }

  public openRedirectModal() {
    const isMarshDomain = window.location.hostname.endsWith('.marsh.com');


    if (!this.env.importantNoticeEnabled || isMarshDomain) {
      return;
    }

    // defer so the launch happens outside the current change-detection pass
    setTimeout(() => {
      this.redirectModalOpen = true;
      window.history.pushState({ importantNotice: true }, '', window.location.href);
      this.redirectModal?.launch();
    }, 0);
  }

  // CDK dialog closes on popstate regardless of disableClose
  @HostListener('window:popstate')
  public onBrowserBack(): void {
    if (!this.redirectModalOpen) {
      return;
    }
    window.history.pushState({ importantNotice: true }, '', window.location.href);
    setTimeout(() => this.redirectModal?.launch(), 0);
  }

  // Chrome restores the frozen page on back/forward, so the notice never reopens
  @HostListener('window:pageshow', ['$event'])
  public onPageShow(event: PageTransitionEvent): void {
    if (event.persisted && this.redirectModalOpen) {
      window.location.reload();
    }
  }

}
